// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_graph_model from "./web_graph_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";

function disabled(form) {
  if (form.loading) {
    return true;
  } else {
    return form.pending;
  }
}

function edit(send, field) {
  return function (param) {
    return Lui_elements.on_input(send, (function (value) {
      return {
        TAG: /* Graph */ 36,
        _0: {
          TAG: /* Change */ 1,
          _0: field,
          _1: value
        }
      };
    }), param);
  };
}

function controls(model, source, send) {
  const partial_arg = "Logseq personal access token";
  const partial_arg$1 = "muted";
  const partial_arg$2 = "Your token identifies the graph automatically.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = Signal.map((function (p) {
    return p.connected !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = edit(send, /* Pat */ 0);
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$2 = "Logseq personal access token";
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
          return p.pat;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.secure_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___002_) {
            const partial_arg = {
              TAG: /* Graph */ 36,
              _0: /* Submit */ 2
            };
            const partial_arg$1 = (function (param) {
              return Lui_elements.press(send, partial_arg, param);
            });
            const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
              return !Mapre_web__Web_graph_model.can_save(p);
            }), source)));
            const partial_arg$3 = "primary";
            const partial_arg$4 = "Connect Logseq graph";
            return function (param, param$1) {
              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$4, (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___003_) {
                const partial_arg = {
                  TAG: /* Graph */ 36,
                  _0: /* Disconnect */ 3
                };
                const partial_arg$1 = (function (param) {
                  return Lui_elements.press(send, partial_arg, param);
                });
                const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(disabled, source)));
                const partial_arg$3 = "outline";
                const partial_arg$4 = "Disconnect Logseq";
                return function (param, param$1) {
                  return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }), param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$6 = 8;
  const partial_arg$7 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
  const partial_arg$8 = Signal.map(Mapre_web__Web_model.can_manage_project, model);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.graph_form, Mapre_web__Web_graph_model.initial(""));
  }), model);
  const partial_arg = "Logseq journal";
  const partial_arg$1 = 2;
  const partial_arg$2 = "New sessions append to the end of the workspace's current journal day. Only Owners and Admins can change this connection.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = Signal.map((function (p) {
    if (p.message !== "") {
      return true;
    } else {
      return p.error !== undefined;
    }
  }), source);
  const partial_arg$5 = {
    TAG: /* Graph */ 36,
    _0: /* Close */ 0
  };
  const partial_arg$6 = (function (param) {
    return Lui_elements.press(send, partial_arg$5, param);
  });
  const partial_arg$7 = "ghost";
  const partial_arg$8 = "Close Logseq";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___007_) {
      const partial_arg = {
        TAG: /* Graph */ 36,
        _0: /* Refresh */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map(disabled, source)));
      const partial_arg$3 = "outline";
      const partial_arg$4 = "Refresh Logseq";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$9 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$10 = "wrap";
  const partial_arg$11 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___004_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (p) {
            if (p.loading) {
              return "Loading Logseq...";
            } else {
              return Stdlib__Option.fold("No Logseq graph connected.", (function (graph) {
                return "Connected graph: " + graph;
              }), p.connected);
            }
          }), source)));
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: controls(model, source, send),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___005_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
                return String(p.waiting) + " session(s) waiting for Logseq.";
              }), source)));
              const partial_arg$1 = "muted";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$4, (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___006_) {
                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
                    if (p.message !== "") {
                      return p.message;
                    } else {
                      return Stdlib__Option.value(p.error, "");
                    }
                  }), source)));
                  const partial_arg$1 = "notice";
                  return function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }), param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.row(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, partial_arg$9, param, param$1);
              }),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const partial_arg$12 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$13 = "form-card";
  const partial_arg$14 = 0;
  const partial_arg$15 = 16;
  const partial_arg$16 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
